import { render, staticRenderFns } from "./View.vue?vue&type=template&id=4377e1f8&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4377e1f8')) {
      api.createRecord('4377e1f8', component.options)
    } else {
      api.reload('4377e1f8', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=4377e1f8&", function () {
      api.rerender('4377e1f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Warehouse/orders/supplier/View.vue"
export default component.exports